exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".action-btn\r\n{\r\n    border: 1px solid #888;\r\n    border-radius: 4px;\r\n    padding: 3px 3px 3px 3px;\r\n    margin-left: 2px;\r\n    margin-right: 2px;\r\n    min-width: 30px;\r\n    height: 30px;\r\n    text-align: center;\r\n    vertical-align: middle;\r\n    background-color: #fff;\r\n    cursor: pointer;\r\n}\r\n.action-btn:hover\r\n{\r\n    background-color: #007ad9;\r\n}\r\n.reminder-number\r\n{\r\n    position: relative;\r\n    top: -8px;\r\n    font-size: 10px;\r\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/ProjectsOnGit/USilence/USilence/Client/src/app/customer-list/customer-list.component.css
// module id = ../../../../../src/app/customer-list/customer-list.component.css
// module chunks = main